import { Card, Button, EmptyState, InlineStack, Icon, Link, Modal, SkeletonBodyText, Text, BlockStack, Badge, Banner, Tooltip, Popover, PopoverCloseSource, TextField, Divider, ProgressBar, Tag } from '@shopify/polaris';
import React, { useEffect, useRef, useState } from 'react';
import { ArrowRightMinor, CircleAlertMajor, CircleCancelMajor, CircleTickMajor, ClockMajor, FilterMinor, InfoMinor, PlusMinor, TickMinor } from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../Core';
import RenderQueueTasks from './RenderQueueTasks';
import NoResultsFound from "../../../../Asests/Images/NoResultsFound.png"
import { Socket, io } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';
import { useTranslation } from 'react-i18next';
import Shopify from "../../../../Asests/Images/shopify.png"
import Amazon from "../../../../Asests/Images/amazon.png"
import { getTimeUntilExpiration, isLinkValid } from '../../Overview/Utils/HelperFunc';
import { notification, Select } from 'antd';
import { isAdminLoggedIn } from '../../Panel/index';
// import FilterComponent from './FilterComponent';
import FilterBy from './FilterBy';
import { InfoIcon } from 'src/Asests/svgIcon/icon';

interface Props extends DIProps {
}

const MAX_RETRIES = 5; // Max reconnection attempts
const INITIAL_RETRY_DELAY = 1000; // 1 second
const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes (600,000ms)

let retryAttempts = 0;
let retryTimeout: NodeJS.Timeout | null = null;
let inactivityTimer: NodeJS.Timeout | null = null;

export const processCodeMapping = (t: (key: string) => string): Record<string, string> => {
    return {
        'price_sync': t('Amazon Price Sync'),
        'saleschannel_product_import': t('Shopify Product Import'),
        'product_import': t('Shopify Product Import'),
        'amazon_product_image': t('Amazon Sync Status'),
        'amazon_product_search': t('Amazon Lookup'),
        'csv_product': t('Bulk Export'),
        'product_upload': t('Amazon Product Upload'),
        'amazon_account': t('Amazon account connection'),
        'product_update': t('Amazon Product Update'),
        'image_sync': t('Amazon Image Sync'),
        'shopify_image_sync': t('Image Sync'),
        'shopify_inventorysync': t('Inventory Sync'),
        'shopify_price_sync': t('Price Sync'),
        'payment': t('Payment Process'),
        'amazon_product_report': t('Amazon Sync Status'),
        'product_delete': t('Amazon Product Delete'),
        'inventory_sync': t('Amazon Inventory Sync'),
        'payment_process_plan': t('Payment Process'),
        'payment_process_settlement': t('Payment Process'),
        'payment_process_custom': t('Payment Process'),
        'payment_process': t('Payment Process'),
        'metafield': t('Shopify Metafield Import'),
        "account_status": t("Amazon Account"),
        "template_bulk_edit_import": t("Bulk Product Attributes Import"),
        "template_bulk_edit_export": t("Bulk Product Attributes Export"),
        "template_bulk_attribute_delete_export": t("Bulk Product Attributes Delete"),
        "batch_product_import": "Shopify Batch Product Import",
        "metafield_import": "Shopify Metafield Import",
        "amazon_product_custom_report": t('Amazon Sync Status'),
        "amazon_fetch_product_type": "Amazon Product type Assignment is in process"
    };
};

const code_mapping: any = {
    'plan': 'Payment Process',
    'amazon': 'Action generated on Amazon',
    'shopify': 'Action generated on Shopify',
    "automatically": 'Action triggered automatically',
    'csv_product': 'Bulk Export',
    amazon_product_search: "Amazon Lookup",
    manually: 'Action(s) triggered mannualy',
    in_progress: 'Action(s) are in progress',
    completed: 'Action(s) are completed',
    failed: 'Failed actions',
    sync_status: "Amazon sync status",
    product_import: 'Product Import',
    amazon_account: "Account Connect",
    today: 'Today',
    Last7days: "Last seven days",
    Last30days: "Last 30 days",
    inventory_sync: 'Inventory Sync',
    product_upload: 'Product Upload',
    image_sync: "Image Sync"

}

function Activities(Props: Props) {
    const { t } = useTranslation();
    let socket: Socket<DefaultEventsMap, DefaultEventsMap>;
    let tempQueuedTask: any = [];
    // const count: number = 5;
    let temp: any = [];

    const [Notification, setNotification] = useState<any>([])
    const [newNotification, setNewNotification] = useState<any>([])
    const [newQueuedTask, setNewQueuedTask] = useState<any>({})
    const [queudTask, setqueudTask] = useState<any>([])
    const [totalCount, settotalCount] = useState<number>(0)
    const [count, setcount] = useState(5)
    const [flag, setflag] = useState(false)
    const [btnLoader, setBtnLoader] = useState<boolean>(false);
    const [loading, setloading] = useState<boolean>(true);
    const [notificationLoading, setNotificationLoading] = useState<boolean>(true);
    const [selected, setSelected] = useState([]);
    // const [currentTaskProgress, setCurrentTaskProgress] = useState<any>({})
    const [queuedTaskId, setQueuedTaskId] = useState<any>([]);
    const [activeToast, setActiveToast] = useState({ open: false, refresh: false });
    const [notificationFlag, setNotificationFlag] = useState<boolean>(false)
    const [active, setActive] = useState(false);
    const [value, setValue] = useState<any>(Props.di.globalState.get('activityFilter', true) ? JSON.parse(Props.di.globalState.get('activityFilter', true) || "{}") : {});

    //this function fetch data of all Queud Task
    function getQueudTasks() {
        const { filter, flagQueuedTask } = prepareFilter(value);
        const shouldCallAPI = flagQueuedTask.inprogress || (!flagQueuedTask.completed && !flagQueuedTask.failed);
        shouldCallAPI && Props.di.GET("connector/get/allQueuedTasks?" + filter).then((Data) => {
            if (Data.success && JSON.stringify(queudTask) != JSON.stringify(Data.data.rows)) {
                let temp: any = [...queuedTaskId];

                Data?.data?.rows?.forEach((task: any) => {
                    temp.push(task?.['_id']?.['$oid'])
                })
                setQueuedTaskId(temp);
                setqueudTask(Data?.data?.rows);
            }
            setloading(false)
        })
    }


    //to get all notification(Continious call)
    const getNotifications = () => {
        const { filter, flagQueuedTask } = prepareFilter(value);
        const shouldCallAPI = !flagQueuedTask.inprogress || flagQueuedTask.completed || flagQueuedTask.failed ||
            (flagQueuedTask.completed && flagQueuedTask.failed);
        shouldCallAPI && Props.di.GET(`connector/get/allNotifications?activePage=1&count=${count}&${filter}`).then((Data) => {
            setBtnLoader(false)
            if (Data.success) {
                const newRows: any = [];
                const rows = Data.data.rows;
                rows.forEach((ele: any) => {
                    newRows.push({
                        ...ele,
                        created_at: new Date(ele.created_at).toUTCString(),
                    });
                });
                setNotification(newRows);
                settotalCount(Data?.data?.count);
            }
            setloading(false)
            setNotificationLoading(false);
        })
    }

    useEffect(() => {
        getQueudTasks()
        getNotifications()
    }, [count, value])

    let wsRef = useRef<WebSocket | null>(null);
    const [isUserActive, setIsUserActive] = useState(true);

    const resetInactivityTimer = () => {
        if (inactivityTimer) {
            clearTimeout(inactivityTimer);
        }

        inactivityTimer = setTimeout(() => {
            setIsUserActive(false);
        }, INACTIVITY_TIMEOUT);
    };



    // Track user activity
    useEffect(() => {
        const updateUserActivity = (event: Event) => {
            let activityType = event.type === "mousemove" ? "Mouse Movement" :
                event.type === "keydown" ? "Key Press" :
                    event.type === "focus" ? "Window Focus" : "Unknown";

            setIsUserActive(true);
            resetInactivityTimer();
        };

        window.addEventListener("mousemove", updateUserActivity);
        window.addEventListener("keydown", updateUserActivity);
        window.addEventListener("focus", updateUserActivity);

        resetInactivityTimer(); // Start inactivity timer when the component mounts

        return () => {
            window.removeEventListener("mousemove", updateUserActivity);
            window.removeEventListener("keydown", updateUserActivity);
            window.removeEventListener("focus", updateUserActivity);
            if (inactivityTimer) {
                clearTimeout(inactivityTimer);
            }
        };
    }, []);

    const connectWebSocket = () => {
        if (!isUserActive) {
            return;
        }

        if (wsRef.current && wsRef.current.readyState !== WebSocket.CLOSED) {
            return; // Prevent duplicate connections
        }

        wsRef.current = new WebSocket('wss://a5zls8ce93.execute-api.us-east-2.amazonaws.com/beta');

        wsRef.current.onopen = () => {
            retryAttempts = 0; // Reset retry counter
            if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
            }
            setActiveToast(prev => ({ ...prev, open: false }));

            const clientIdString = process.env.REACT_APP_WEBSOCKET_CLIENT_ID;
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN && clientIdString) {
                wsRef.current.send(JSON.stringify({
                    action: "identity",
                    client_id: parseInt(clientIdString),
                    customer_id: Props.di.globalState.get("user_id"),
                    token: Props.di.globalState.getBearerToken()
                }));
            }
        };

        wsRef.current.onmessage = (event) => {
            const data = JSON.parse(event?.data);
            if (data.feed && !Array.isArray(data.feed)) {
                if (data.feed.shop_id === Props?.redux?.current?.source?._id || data.feed.shop_id === Props?.redux?.current?.target?._id) {
                    setNewQueuedTask(data.feed);
                }
            } else if (data.notification && !Array.isArray(data.notification)) {
                if (data.feed.shop_id === Props?.redux?.current?.source?._id || data.feed.shop_id === Props?.redux?.current?.target?._id) {
                    setNewNotification(data.notification);
                }
            }
        };

        wsRef.current.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        wsRef.current.onclose = () => {
            setActiveToast(prev => ({ ...prev, open: true }));

            if (isUserActive) {
                handleReconnect();
            } else {
                console.log('User has been inactive for 10 minutes. Not reconnecting.');
            }
        };
    };

    const handleReconnect = () => {
        setTimeout(() => {
            setIsUserActive((currentIsUserActive) => {
                if (!currentIsUserActive) {
                    return false; // Ensure no reconnection
                }

                if (retryAttempts >= MAX_RETRIES) {
                    console.error("Max WebSocket reconnection attempts reached");
                    return true; // Stop further retries
                }

                const retryDelay = INITIAL_RETRY_DELAY * Math.pow(2, retryAttempts);

                retryAttempts++;
                connectWebSocket();
                return true;
            });
        }, 1000); // Wait 1 second before checking again
    };

    useEffect(() => {
        getNotifications();
        getQueudTasks();
        connectWebSocket();

        return () => {
            if (wsRef.current) {
                wsRef.current.close();
            }
            if (retryTimeout) {
                clearTimeout(retryTimeout);
            }
            if (inactivityTimer) {
                clearTimeout(inactivityTimer);
            }
        };
    }, [activeToast.refresh]);


    useEffect(() => {
        if (Object.keys(value).length < 1) {
            let temp: any = [{ ...newNotification }, ...Notification,]
            setNotification([...temp])
        }
    }, [newNotification])

    useEffect(() => {
        if (Object.keys(value).length < 1 && Object.keys(newQueuedTask).length > 0) {
            if (newQueuedTask.progress === 100) {
                // Remove the task from the queue if progress is 100
                setqueudTask((prevQueue: any) => {
                    return prevQueue.filter((task: any) => task?._id?.$oid !== newQueuedTask?._id?.$oid);
                });
            } else {
                // Task progress is not 100, update or add it to the queue
                setqueudTask((prevQueue: any) => {
                    const existingIndex = prevQueue.findIndex((task: any) => task?._id?.$oid === newQueuedTask?._id?.$oid);
                    if (existingIndex !== -1) {
                        // Task already exists, update it
                        const updatedQueue = [...prevQueue];
                        updatedQueue[existingIndex] = { ...newQueuedTask };
                        return updatedQueue;
                    } else {
                        // Task doesn't exist, add it to the queue
                        return [{ ...newQueuedTask }, ...prevQueue];
                    }
                });
            }
        }

    }, [newQueuedTask]);

    // useEffect(() => {
    //     let temp: any = [...queudTask];
    //     temp?.forEach((task: any) => {
    //         if (task?.['_id'] == currentTaskProgress?.['_id'] || task?.['_id']?.['$oid'] == currentTaskProgress?.['_id']) {
    //             task['progress'] = currentTaskProgress?.['progress'];
    //         }
    //     })
    //     setqueudTask(temp);
    // }, [currentTaskProgress]);

    useEffect(() => {
        if (totalCount / count <= 1) {
            setflag(false);
        }
        else {
            setflag(true)
        }
    }, [count, totalCount])

    //render skeleton for activity section
    const renderSkeleton = () => {
        let n = 5
        return (
            <React.Fragment>
                {
                    [...Array(n)].map((elementInArray, index) => (
                        <Card key={index} roundedAbove='sm'>
                            <SkeletonBodyText lines={2} />
                        </Card>
                    ))
                }
            </React.Fragment>

        )
    }

    //this function is used to load more activities
    const handleLoadMore = () => {
        setBtnLoader(true);
        if (totalCount / count >= 1) {
            setcount(count + 5)
        }
        else if (totalCount - count > 0) {
            setcount(totalCount - count)
        }
    }

    // USED FOR NOTIFICATION ICON SELECTION IT ACCEPS THE VALUE IN STRING /WARNING/SUCCESS/ATTENTION
    function imageselction(value: string) {
        switch (value) {
            case "warning":
                return <div><Icon source={CircleAlertMajor} tone="caution" /></div>;
            case "attention":
                return <div><Icon source={CircleAlertMajor} tone="caution" /></div>;
            case "info":
                return <div><Icon source={CircleAlertMajor} tone="caution" /></div>;
            case "success":
                return <div><Icon source={CircleTickMajor} tone="success" /></div>;
            case "critical":
                return <div><Icon source={CircleCancelMajor} tone="critical" /></div>;
            default:
                return <div><Icon source={CircleAlertMajor} tone="caution" /></div>;
        }
    }

    const prepareFilter = (value: any) => {
        let filter = '';
        let flagQueuedTask = {
            completed: false,
            inprogress: false,
            failed: false
        };

        Object.keys(value).forEach((key) => {
            setloading(true);
            switch (key) {
                case 'sync_status':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=amazon_product_report`
                    }
                    break;
                case 'amazon_product_search':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=amazon_product_search`
                    }
                    break;

                case 'product_import':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=saleschannel_product_import`
                        filter = `${filter}&or_filter[process_code][]=product_import`
                    }
                    break;
                case 'inventory_sync':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=inventory_sync`
                    }
                    break;
                case 'product_upload':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=product_upload`
                    }
                    break;
                case 'image_sync':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=image_sync`
                    }
                    break;
                case 'plan':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=payment_process`
                        filter = `${filter}&or_filter[process_code][]=payment`
                        filter = `${filter}&or_filter[process_code][]=payment_process_custom`
                        filter = `${filter}&or_filter[process_code][]=payment_process_settlement`
                        filter = `${filter}&or_filter[process_code][]=payment_process_plan`
                    }
                    break;
                case 'amazon_account':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=amazon_account`

                    }
                    break;
                case 'csv_product':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_code][]=csv_product`

                    }
                    break;

                case 'amazon':
                    if (value[key]) {
                        filter = `${filter}&or_filter[shop_id][]=${Props?.redux?.current?.target?._id}`
                    }
                    break;
                case 'shopify':
                    if (value[key]) {
                        filter = `${filter}&or_filter[shop_id][]=${Props?.redux?.current?.source?._id}`
                    }
                    break;
                case 'automatically':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_initiation][]=automatic`
                    }
                    break;
                case 'manually':
                    if (value[key]) {
                        filter = `${filter}&or_filter[process_initiation][]=manual`
                    }
                    break;
                case 'in_progress':
                    if (value[key]) {
                        setNotification([])
                        flagQueuedTask = {
                            ...flagQueuedTask,
                            inprogress: true
                        }
                    }
                    break;
                case 'completed':
                    if (value[key]) {
                        flagQueuedTask = flagQueuedTask = {
                            ...flagQueuedTask,
                            completed: true
                        }
                    }
                    break;
                case 'failed':
                    if (value[key]) {
                        setNotification([])
                        flagQueuedTask = {
                            ...flagQueuedTask,
                            failed: true
                        }
                        filter = `${filter}&or_filter[severity][]=critical`
                    }
                    break;
                case 'custom_filter_date':
                    if (value[key] && value[key]?.from && value[key]?.to) {
                        const sinceDate = new Date(value[key]?.from);
                        const untilDate = new Date(value[key]?.to);
                        const sinceDateUTC = new Date(Date.UTC(
                            sinceDate.getFullYear(),
                            sinceDate.getMonth(),
                            sinceDate.getDate(),
                            0, 0, 0, 0
                        ));
                        const untilDateUTC = new Date(Date.UTC(
                            untilDate.getFullYear(),
                            untilDate.getMonth(),
                            untilDate.getDate(),
                            23, 59, 59, 999
                        ));

                        const sinceDateISO = sinceDateUTC.toISOString();
                        const untilDateISO = untilDateUTC.toISOString();

                        // Constructing the filter string
                        filter += `&filter[created_at][7][from]=${sinceDateISO}&filter[created_at][7][to]=${untilDateISO}`;
                    }
                    break;
                case 'today':
                    if (value[key]) {
                        const now = new Date();

                        // Calculate the start of today in UTC
                        const sinceDateUTC = new Date(Date.UTC(
                            now.getUTCFullYear(),
                            now.getUTCMonth(),
                            now.getUTCDate(),
                            0, 0, 0, 0
                        ));

                        // Calculate the end of today in UTC (23:59:59.999)
                        const untilDateUTC = new Date(Date.UTC(
                            now.getUTCFullYear(),
                            now.getUTCMonth(),
                            now.getUTCDate(),
                            23, 59, 59, 999
                        ));
                        const sinceDateISO = sinceDateUTC.toISOString();
                        const untilDateISO = untilDateUTC.toISOString();

                        // Constructing the filter string
                        filter += `&filter[created_at][7][from]=${sinceDateISO}&filter[created_at][7][to]=${untilDateISO}`;
                    }
                    break;
                case 'Last7days':
                    if (value[key]) {
                        // Get the current date
                        const now = new Date();

                        // Calculate the start of the current day in UTC (00:00:00.000)
                        const endOfTodayUTC = new Date(Date.UTC(
                            now.getUTCFullYear(),
                            now.getUTCMonth(),
                            now.getUTCDate(),
                            23, 59, 59, 999
                        ));

                        // Calculate the start of the date seven days ago in UTC (00:00:00.000)
                        const startOfLastSevenDaysUTC = new Date(Date.UTC(
                            now.getUTCFullYear(),
                            now.getUTCMonth(),
                            now.getUTCDate() - 6,  // 6 days ago to include today as the seventh day
                            0, 0, 0, 0
                        ));

                        // Convert to ISO strings
                        const startOfLastSevenDaysISO = startOfLastSevenDaysUTC.toISOString();
                        const endOfTodayISO = endOfTodayUTC.toISOString();

                        // Constructing the filter string using ISO strings
                        filter += `&filter[created_at][7][from]=${startOfLastSevenDaysISO}&filter[created_at][7][to]=${endOfTodayISO}`;
                    }
                    break;
                case 'Last30days':
                    if (value[key]) {
                        // Get the current date
                        const now = new Date();

                        // Calculate the end of today in UTC (23:59:59.999)
                        const endOfTodayUTC = new Date(Date.UTC(
                            now.getUTCFullYear(),
                            now.getUTCMonth(),
                            now.getUTCDate(),
                            23, 59, 59, 999
                        ));

                        // Calculate the start of the date 30 days ago in UTC (00:00:00.000)
                        const startOfLastThirtyDaysUTC = new Date(Date.UTC(
                            now.getUTCFullYear(),
                            now.getUTCMonth(),
                            now.getUTCDate() - 29,  // 29 days ago to include today as the 30th day
                            0, 0, 0, 0
                        ));

                        // Convert to ISO strings
                        const startOfLastThirtyDaysISO = startOfLastThirtyDaysUTC.toISOString();
                        const endOfTodayISO = endOfTodayUTC.toISOString();

                        // Constructing the filter string using ISO strings
                        filter += `&filter[created_at][7][from]=${startOfLastThirtyDaysISO}&filter[created_at][7][to]=${endOfTodayISO}`;
                    }
                    break;

            }
        });
        return { filter, flagQueuedTask };


    }

    const handleclose = () => {
        setNotificationLoading(true);
        setloading(true);
        setActiveToast({ open: false, refresh: !activeToast.refresh })
    }
    const removeFilter = (key: any) => {
        let temp: any = { ...value }
        delete temp[key]
        setValue(temp)
        Props.di.globalState.set("activityFilter", JSON.stringify(temp))

    }
    return (
        <Card>
            <BlockStack gap="500" >
                <InlineStack gap={'600'} align="space-between">
                    <Text as="p" variant="bodyLg" fontWeight="medium">
                        {t("Activities")}
                    </Text>
                    <Button
                        icon={FilterMinor}
                        variant="secondary"
                        onClick={() => setActive(!active)}>
                        {t("Filter by")}
                    </Button>
                </InlineStack>
                <InlineStack gap={'150'}>
                    {Object.keys(value).map((key: any) => {
                        if (value[key] && key != 'custom_filter_date') {
                            return <Tag onRemove={() => removeFilter(key)}>{code_mapping[key]}</Tag>
                        } else if (value[key] && key === 'custom_filter_date' && value[key]?.from && value[key]?.to) {
                            return <Tag onRemove={() => removeFilter(key)}>{`Date from ${new Date(value[key]?.from).toDateString()} to ${new Date(value[key]?.to).toDateString()}`}</Tag>
                        }
                    })}

                </InlineStack>

                {/* <FilterComponent value={value} {...Props} setValue={setValue} prepareFilter={prepareFilter} /> */}
                {loading || notificationLoading ?
                    renderSkeleton()
                    :
                    (Notification.length > 0 || queudTask.length > 0)
                        ?
                        <BlockStack gap="500">
                            <RenderQueueTasks {...Props} queudTask={queudTask?.reverse()} />
                            <RenderAllNotifications t={t} Notification={Notification} Props={Props} imageselction={imageselction} setNotification={setNewNotification} setFlag={setNotificationFlag} flag={notificationFlag} />
                            {flag && <InlineStack gap="400" align='center'>
                                <Button onClick={() => handleLoadMore()} loading={btnLoader}>{t("Load More")}</Button>
                            </InlineStack>}
                        </BlockStack>
                        :
                        <Card roundedAbove='sm'>
                            <EmptyState
                                image={NoResultsFound}
                                heading={t("No Activities found!")}
                            />
                        </Card>
                }
                <FilterBy {...Props} selected={selected} setSelected={setSelected} value={value} setValue={setValue} active={active} setActive={setActive} />

            </BlockStack>
        </Card>
    );
};

// RENDER ALL THE NOTIFICATION FROM NOTIFICATION API
const RenderAllNotifications = ({ setFlag, t, flag, Notification, Props, imageselction, setNotification }: any) => {
    function renderNotificationAction(m: any, k: number) {
        if (m.hasOwnProperty('do_notify') && m['do_notify'] === 'link')
            return <Link target='_blank' url={m['content']}>know more</Link>
    }
    return (
        <>
            {Notification.map((m: any, k: number) => {
                let createdAtTimestamp;
                if (m.created_at && m.created_at.$date && typeof m.created_at.$date === 'object' && m.created_at.$date.$numberLong) {
                    createdAtTimestamp = parseInt(m.created_at.$date.$numberLong);
                } else {
                    // Fallback: parse as ISO date string
                    createdAtTimestamp = Date.parse(m.created_at);
                }

                // Convert the timestamp to a Date object
                const createdAtDate = new Date(createdAtTimestamp);

                // Format the date to your desired format (e.g., "YYYY-MM-DD HH:MM:SS")
                const formattedDate = `${createdAtDate.getFullYear()}-${String(createdAtDate.getMonth() + 1).padStart(2, '0')}-${String(createdAtDate.getDate()).padStart(2, '0')} ${String(createdAtDate.getHours()).padStart(2, '0')}:${String(createdAtDate.getMinutes()).padStart(2, '0')}:${String(createdAtDate.getSeconds()).padStart(2, '0')}`;


                m['created_at'] = formattedDate;
                return (
                    <RenderNotification key={k} t={t} {...Props} setFlag={setFlag} flag={flag} imageselction={imageselction} m={m} k={k} Notification={Notification} setNotification={setNotification} renderNotificationAction={renderNotificationAction} />

                );
            })}
        </>
    );
}


const RenderNotification = (Props: any) => {

    const [flag, setFlag] = useState<boolean>(false)

    const { m, Notification, imageselction, k, t, setNotification, renderNotificationAction } = Props
    const handleCSVfile = (Activitydata: any) => {
        const payload = {
            _id: Activitydata['_id']['$oid'] ?? Activitydata['_id'],
            url: Activitydata?.url
        }
        Props.di.GET("connector/csv/S3fileDownload", payload).then((data: any) => {
            if (data.success) {
                const link = document.createElement('a');
                link.href = Activitydata?.url;
                link.setAttribute('download', ''); // This attribute triggers the download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                let TempNotification = [...Notification]
                let foundIndex = TempNotification.findIndex((item: any) => item._id["$oid"] === data?.data?._id?.['$oid'] || item._id === data?.data?._id?.['$oid']);
                if (foundIndex !== -1) {
                    // Update desired keys
                    TempNotification[foundIndex].additional_data.downloaded = data?.additional_data?.downloaded ?? true;
                    TempNotification[foundIndex].additional_data.current = true;
                }
                setNotification([...TempNotification])
                Props.success(t("File Downloaded Started"))
            } else {
                Props.error(t(data?.message))
            }
        })
    }
    const getIconType: any = {
        inProgress: <Icon source={ClockMajor} tone="warning" />,
        error: <Icon source={CircleCancelMajor} tone="critical" />,
        success: <Icon source={CircleTickMajor} tone="success" />,
    };

    return (
        <React.Fragment key={k}>
            <BlockStack gap='200'>
                <InlineStack align='space-between'>
                    <InlineStack gap="200" align='start'>
                        <Text variant="headingMd" as="h6">{m?.additional_data?.process_label ?? processCodeMapping(t)[m?.process_code] ?? t("App Process")}</Text>
                        {m?.['process_initiation'] ? <Badge>{m?.process_initiation.charAt(0).toUpperCase() + m?.process_initiation.slice(1)}</Badge> : null}
                    </InlineStack>
                    <img alt='shopify' src={Props?.redux?.current?.target?.['_id'] == m?.shop_id ? Amazon : Shopify} />
                </InlineStack>
                <InlineStack blockAlign='start' align="space-between">
                    <InlineStack wrap={false} gap={"100"}>
                        <div>{imageselction(m["severity"])}</div>
                        <BlockStack gap='100'>
                            {m['url'] ? (
                                <InlineStack gap='200'>
                                    <Text as='p'>{t(m["message"])}</Text>
                                    {isLinkValid(m?.created_at) ? (
                                        <Button variant='plain' onClick={() => handleCSVfile(m)}>
                                            {t("Download Now")}
                                        </Button>
                                    ) : null}
                                </InlineStack>
                            ) : (
                                m?.['additional_data']?.['force_delete'] ?
                                    <InlineStack>
                                        <Text as='p'>
                                            {t(m["message"])}
                                        </Text>
                                        <Tooltip content={m?.['additional_data']?.['force_delete']}>
                                            <Icon source={InfoMinor}></Icon>
                                        </Tooltip>
                                    </InlineStack> :
                                    <Text as='p'>
                                        {t(m["message"])}
                                    </Text>

                            )}
                            {renderNotificationAction(m, k)}
                            {
                                m['url'] && <Timer t={t} setFlag={setFlag} flag={flag} createdAt={(m?.created_at)}></Timer>
                            }
                        </BlockStack>
                    </InlineStack>
                    <Text variant="bodyMd" as="p" tone="subdued">
                        {m['created_at'] != undefined && <Text as='span' tone='subdued'>{new Date(m.created_at).toUTCString()}</Text>}
                    </Text>
                </InlineStack>
            </BlockStack>
            {Notification.length - 1 !== k && (
                <Divider borderColor="border-secondary" />
            )}
        </React.Fragment>

    )
}




export function Timer({ createdAt, setFlag, flag }: any) {
    const { t } = useTranslation();

    const [timeLeft, setTimeLeft] = useState(getTimeUntilExpiration(createdAt));
    const [expired, setExpired] = useState(!isLinkValid(createdAt));

    useEffect(() => {
        setExpired(!isLinkValid(createdAt))
        const timer = setInterval(() => {
            const timeUntilExpiration = getTimeUntilExpiration(createdAt);
            setTimeLeft(timeUntilExpiration);
            if (timeUntilExpiration.hours === 0 && timeUntilExpiration.minutes === 0 && timeUntilExpiration.seconds === 0) {
                setExpired(true);
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [createdAt]);

    if (expired) {
        setFlag(!flag)
        return <InlineStack>
            <Banner hideIcon tone='critical'>
                <Text as='p'>{`Download link is Expired`}</Text>
            </Banner>
        </InlineStack>
    }

    return (
        <InlineStack>
            <Banner hideIcon tone='warning'>
                <Text as='p'> {`${t("Download link is valid for")} ${timeLeft.hours}h ${timeLeft.minutes}m ${timeLeft.seconds}s`}</Text>
            </Banner>
        </InlineStack>
    );
}

export default DI(Activities)